import axios from 'axios'

export async function logEvent(type, properties = {}) {
  return axios.post('/api/log-event/', {
    type,
    properties,
  })
}
